export default __webpack_public_path__ + "static/exterior_a-e8899f6fec693cf5f05b68ec800a9b8f.jpg";